import clsx from "clsx";
import React, { useState } from "react";

import { toast } from "~/helpers/toaster.client";

interface ButtonProps {
  children: React.ReactNode,
}

const CodeBlock: React.FC<ButtonProps> = (
  {
    children
  }
) => {
  const [isHovered, setIsHovered] = useState(false);

  const copyToClipBoard = async (copyMe: React.ReactNode) => {
    if (!copyMe) {
      return;
    }

    let str: string;
    switch (true) {
      case Array.isArray(copyMe):
        str = copyMe.join("");
        break;
      default:
        str = copyMe.toString();
    }

    try {
      await navigator.clipboard.writeText(str);
      toast("Copied to clipboard!");
    } catch (err) {
      toast("Failed to copy to clipboard");
    }
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="relative my-2"
    >
      {isHovered ? <button
          className="absolute top-0 right-0 m-2 p-2 bg-slate-500 rounded-lg text-slate-100"
          onClick={() => copyToClipBoard(children)}
        >
          Copy
        </button> : null}
      <pre className="bg-slate-300 dark:bg-slate-700 p-4 rounded-lg"
      >
        <code>
            {children}
        </code>
      </pre>
    </div>
  );

};

export default CodeBlock;
